export const SALE_SOURCES_REMOVE_STALE = 'SALE_SOURCES_REMOVE_STALE';
